<style>
root {
  --display-fake-color: #000000 !important;
}

.cross-top-right {
  margin-right: 25px;
  margin-top: 5px;
  top: 0px;
  right: 0px;
}
.cross-top-right:after {
  left: -20px;
  top: 20px;
}
.cross-top-left {
  margin-left: 25px;
  margin-top: 5px;
  top: 0px;
  left: 0px;
}
.cross-top-left:after {
  right: -20px;
  top: 20px;
}
.cross-bottom-right {
  margin-right: 25px;
  margin-bottom: 5px;
  bottom: 0px;
  right: 0px;
}
.cross-bottom-right:after {
  left: -20px;
  bottom: 20px;
}
.cross-bottom-left {
  margin-left: 25px;
  margin-bottom: 5px;
  bottom: 0px;
  left: 0px;
}
.cross-bottom-left:after {
  right: -20px;
  bottom: 20px;
}
.cross-center {
  margin-bottom: 5px;
  bottom: calc(50% - 25px);
  left: calc(50% - 2px);
}
.cross-center:after {
  right: -20px;
  bottom: 20px;
}
.fake-profile-cross {
  background: var(--display-fake-color);
  height: 50px;
  width: 10px;
  position: absolute;
  opacity: 0.6;
  filter: alpha(opacity=80);
  transform: rotate(45deg);
}
.fake-profile-cross:after {
  background: var(--display-fake-color);
  content: "";
  height: 10px;
  width: 50px;
  position: absolute;
}
</style>

<template>
  <div class="row pl-3 pr-3">
    <div class="col-12 bg-white border rounded shadow">
      <div class="row">
        <div class="p-2 text-center col-12 col-md-5 col-lg-5 col-xl-6">
          <div class="profile-picture-placeholder">
            <img
              @click="
                $modal.show('image-modal', {
                  image: profile_visited.primary_image.url
                })
              "
              class="rounded profile-picure w-100"
              :src="primaryImageUrl"
            />
            <div v-if="mark.mode == 'cross' && profile_visited.mark">
              <div
                v-if="mark.location == 'topRight'"
                class="fake-profile-cross cross-top-right"
              ></div>
              <div
                v-if="mark.location == 'topLeft'"
                class="fake-profile-cross cross-top-left"
              ></div>
              <div
                v-if="mark.location == 'bottomRight'"
                class="fake-profile-cross cross-bottom-right"
              ></div>
              <div
                v-if="mark.location == 'bottomLeft'"
                class="fake-profile-cross cross-bottom-left"
              ></div>
              <div
                v-if="mark.location == 'center'"
                class="cross-center fake-profile-cross"
              ></div>
            </div>
            <audio
              v-if="profile_visited.primary_audio !== null"
              class="mw-100"
              controls
              :src="profile_visited.primary_audio.url"
            />
          </div>
          <a v-if="myselfViewing" class="text-link" href="/Einstellungen"
            >(Möchtest du deine Stammdaten ändern?)</a
          >
        </div>
        <div class="pl-2 pt-3 col-12 col-md-7 col-lg-7 col-xl-6 ">
          <div class="row">
            <div class="container profile-content">
              <div class="row pl-3 pr-3">
                <div class="profile-name col-5 pr-1">
                  {{ profile_visited.name }}
                </div>
                <status-bubble
                  class="d-none d-sm-block pl-1 pt-2 col-7 text-right"
                  :isOnline="isOnline"
                  onlineText="Ich bin gerade online!"
                  offlineText="Ich bin leider offline"
                ></status-bubble>
                <status-bubble
                  class="d-sm-none pl-1 pt-2 col-7 text-right"
                  :isOnline="isOnline"
                  onlineText="Online!"
                  offlineText="Offline"
                ></status-bubble>
              </div>
              <div class="text-primary text-md pl-3 pr-2 pt-5">
                <span v-if="profile_visited.age"
                  >{{ profile_visited.age }} Jahre,</span
                >
                <span v-if="profile_visited.sex"
                  >{{ profile_visited.sex }},</span
                >
                <span v-if="profile_visited.physique">{{
                  profile_visited.physique
                }}</span>
                <span v-if="profile_visited.height_in_cm"
                  >({{ profile_visited.height_in_cm }} cm groß)</span
                >
              </div>
              <div v-if="isAuth" class="text-primary pl-3 pr-2 pb-4">
                aus {{ profile_visited.country }}:
                {{ profile_visited.anonymous_zipcode }}
              </div>
              <div v-else class="text-primary pl-3 pr-2 pb-4">
                aus <strong>(Nur für Mitglieder sichtbar)</strong>
              </div>
              <textbox-quoted
                v-if="profile_visited.interested_in_gender"
                class="text-center"
                :text="quotaText()"
              ></textbox-quoted>
              <description
                :profile="profile_visited"
                :can-update="myselfViewing"
              ></description>
              <profile-buttons
                :disabled="myselfViewing"
                :is-friend="isFriend"
                :profile="profile_visited"
                class="col-12 pt-3"
              ></profile-buttons>
            </div>
          </div>
        </div>
        <customer-map
          v-if="
            isAuth &&
              my_profile.latitude &&
              my_profile.longitude &&
              profile_visited.anonymousLocation.latitude &&
              profile_visited.anonymousLocation.longitude
          "
          class="col-12 pt-4"
          :my_profile="my_profile"
          :profile_visited="profile_visited"
        ></customer-map>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import ProfileButtons from './profile/ProfileButtons.vue';
import StatusBubble from './profile/StatusBubble.vue';
import CustomerMap from '@/components/Customer/CustomerMap.vue';
import Description from './profile/Description.vue';

export default {
    components: {
      ProfileButtons,
      StatusBubble,
      CustomerMap,
      Description
    },
    data () {
      return {
        friend: false,
        mobile: false,
      };
    },
    props: {
      profile_visited: {
        required: true,
        type: Object
      },
      my_profile: {
        required: true,
        validator: prop => typeof prop === 'object' || prop === null
      }
    },
    methods: {
        isMobileView() {
           return (window.innerWidth < 700)
        },
        quotaText(){
            let lookingFor = "";
            if(this.profile_visited.interested_in_gender && this.profile_visited.interested_in_gender.includes("Mann")) {
              lookingFor = "Männer";
            }

            if(this.profile_visited.interested_in_gender && this.profile_visited.interested_in_gender.includes("Frau")) {
              (lookingFor != "") ? lookingFor += " sowie Frauen" : lookingFor = "Frauen";
            }

            lookingFor = `Ich suche nach ${lookingFor}`;
            if (this.profile_visited.i_search_for_activity !== null) {
              lookingFor = `${lookingFor} und ich bin interessiert an: ${this.profile_visited.i_search_for_activity.map(element => {return "\n"+element})}`;
            }
            return lookingFor;
        },
    },
    created() {
      document.body.style.setProperty('--display-fake-color', this.mark.color);
      this.mobile = this.isMobileView();
    },
    mounted() {
      window.addEventListener("resize", () => {
        this.mobile = this.isMobileView();
      });
    },
    computed: {
      formPlaceholer(){
        return this.myselfViewing ?
          "Du kannst die Nachricht nicht an Dich selbst verschicken!" :
          "Schreibe eine Nachricht...";
      },
      isFriend() {
        return (this.myselfViewing ? true : this.friend)
      },
      me() {
        return this.$store.getters["user/me"];
      },
      isAuth() {
        return this.$store.getters["user/auth"];
      },
      isOnline() {
        return this.$store.getters["online/profileOnline"](this.profile_visited.id);
      },
      myselfViewing() {
        if (!this.my_profile) {
          return false;
        }

        return this.my_profile.id === this.profile_visited.id;
      },
      primaryImageUrl() {
        return this.profile_visited.primary_image.url + '?width=' + Laravel.settings.imagesize.primaryImages + '&height=' + Laravel.settings.imagesize.primaryImages;
      },
      mark() {
        return Laravel.mark;
      }
    }
  };
</script>
